import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_currSetMenuCode} from "../../../../../function/FnBodyMenu";
import {comma} from "../../../../../utils/Utils";

@observer
class OrderMenuListItemView extends Component {
    render() {
        const { rootStore, menu } = this.props;
        let sideMenuSoldOut = "";
        if( Array.isArray(menu.sdsList) && menu.sdsList.length > 0 ) {
            menu.sdsList.map(menuGroup => {
                if (Array.isArray(menuGroup.sdsProdList) && menuGroup.sdsProdList.length > 0) {
                    menuGroup.sdsProdList.map(sideMenu => {
                        if (sideMenu.soldOut === "Y")
                            sideMenuSoldOut = "Y"
                    })
                }
            })
        }
        return (
            <li>
                <button type="button"
                        onClick={event=>{fn_currSetMenuCode(rootStore, menu.prodCd, menu)}}
                        className={(menu.soldOut==='Y')?"soldout":null}
                    >
                    <strong>{menu.prodNm}</strong>
                    <span>{comma(menu.saleUprc.toString())}원</span>
                    {(sideMenuSoldOut === 'Y')?<em>사이드 품절</em>:null}
                </button>
            </li>
        );
    }
}

export default OrderMenuListItemView;